import { createTheme, Theme } from "@mui/material";
import { types } from "@vilocnv/allsetra-core";

export const getMuiCustomTheme = (
  whiteLabel?: types.IWhiteLabel | null
): Theme =>
  createTheme({
    palette: {
      primary: {
        light: "#F5FFFE", // brand/primary/100
        main: whiteLabel?.primaryColor || "#00B2A3", // brand/primary/500
        dark: "#00E2D1", // brand/primary/400
        contrastText: whiteLabel?.highlightColor || "#00968A" //// brand/primary/600
      },
      secondary: {
        light: "#D5D9E8", // gray/300
        main: whiteLabel?.secondaryColor ?? "#646D7B", // gray/600
        dark: "#1D1F2B" // gray/900
      },
      info: {
        light: "#A4C8FF", // blue/300
        main: "#0269EC", // blue/600
        dark: "#0152B8", // blue/700
        contrastText: "#FFFFFF" // white for contrast
      },
      error: {
        light: "#FA8282", // red/100
        main: "#CC1010", // red/600
        dark: "#A00D0D", // red/700
        contrastText: "#FFFFFF" // white for contrast
      },
      success: {
        light: "#8ED78C", // green/300
        main: "#148E20", // green/600
        dark: "#0F6B18", // green/700
        contrastText: "#FFFFFF" // white for contrast
      },
      warning: {
        light: "#FACA82", // orange/300
        main: "#E28E10", // orange/600
        dark: "#B3700D", // orange/700
        contrastText: "#FFFFFF" // white for contrast
      }
    },
    typography: {
      h1: {
        fontSize: 55,
        fontWeight: 800,
        lineHeight: "100%",
        color: "#1D1F2B"
      },
      h2: {
        fontSize: 33,
        fontWeight: 800,
        lineHeight: "100%",
        color: "#1D1F2B"
      },
      h3: {
        fontSize: 24,
        fontWeight: 800,
        lineHeight: "36px",
        color: "#1D1F2B"
      },
      subtitle1: {
        fontSize: 18,
        fontWeight: 700,
        lineHeight: "16px",
        color: "#000"
      },
      subtitle2: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "16px",
        color: "#323946"
      },
      body1: {
        fontSize: 16,
        lineHeight: "24px",
        fontWeight: 400,
        color: "#1D1F2B"
      },
      body2: {
        fontSize: 12,
        lineHeight: "16px",
        fontWeight: 400,
        color: "#1D1F2B"
      }
    }
  });
